export default __webpack_public_path__ + "static/DEIPage-pattern-medium-lightblue-4db9a305a194daef3aa596893416ae1e.png";